export const STATIC_LANGUAGES = [
  {
    "language": "English",
    "abbreviation": "en"
  },
  {
    "language": "Hindi",
    "abbreviation": "hi"
  },
  {
    "language": "Tamil",
    "abbreviation": "ta"
  },
  {
    "language": "Telugu",
    "abbreviation": "te"
  },
  {
    "language": "Marathi",
    "abbreviation": "mr"
  },
  {
    "language": "Bengali",
    "abbreviation": "bn"
  },
  {
    "language": "Kannada",
    "abbreviation": "kn"
  },
  {
    "language": "Maithili",
    "abbreviation": "mai"
  },
  {
    "language": "Punjabi",
    "abbreviation": "pa"
  },
  {
    "language": "Manipuri",
    "abbreviation": "mni"
  },
  {
    "language": "Bodo",
    "abbreviation": "brx"
  },
  {
    "language": "Haryanvi",
    "abbreviation": "bgc"
  },
  {
    "language": "Bihari languages",
    "abbreviation": "bh"
  },
  {
    "language": "Santali",
    "abbreviation": "sat"
  },
  {
    "language": "Assamese",
    "abbreviation": "as"
  },
  {
    "language": "Dogri",
    "abbreviation": "doi"
  },
  {
    "language": "Gujarati",
    "abbreviation": "gu"
  },
  {
    "language": "Konkani",
    "abbreviation": "kok"
  },
  {
    "language": "Malayalam",
    "abbreviation": "ml"
  },
  {
    "language": "Oriya",
    "abbreviation": "or"
  },
  {
    "language": "Sanskrit",
    "abbreviation": "sa"
  },
  {
    "language": "Sindhi",
    "abbreviation": "sd"
  },
  {
    "language": "Urdu",
    "abbreviation": "ur"
  },
  {
    "language": "Kashmiri",
    "abbreviation": "ks"
  },
  {
    "language": "Nepali",
    "abbreviation": "ne"
  },
  {
    "language": "Garhwali",
    "abbreviation": "gb"
  },
  {
    "language": "Khasi",
    "abbreviation": "kha"
  },
  {
    "language": "Lushai",
    "abbreviation": "lus"
  },
  {
    "language": "Limbu",
    "abbreviation": "lif"
  },
  {
    "language": "Miji",
    "abbreviation": "cm"
  },
  {
    "language": "Garo",
    "abbreviation": "gr"
  },
  {
    "language": "Khandeshi",
    "abbreviation": "kh"
  },
  {
    "language": "Laitu",
    "abbreviation": "cl"
  }
];